module.exports = __webpack_public_path__ + "static/media/bath.3def6397.svg";